import { render, staticRenderFns } from "./resueltas.vue?vue&type=template&id=49da00c6&scoped=true"
import script from "./resueltas.vue?vue&type=script&lang=js"
export * from "./resueltas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49da00c6",
  null
  
)

export default component.exports